export default {"src":"/_next/static/media/character-d.colour.b426ee53.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};